import { render, staticRenderFns } from "./OrdersHeader.vue?vue&type=template&id=3a38a364&"
import script from "./OrdersHeader.vue?vue&type=script&lang=js&"
export * from "./OrdersHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports